export default __webpack_public_path__ + "static/media/react.928f956d.svg";